
export const UrlClient = window.location.host;